export default __webpack_public_path__ + "static/media/women.c6a598af.svg";